import { render, staticRenderFns } from "./JdsCandidateBubble.vue?vue&type=template&id=6885cd28&scoped=true&"
import script from "./JdsCandidateBubble.vue?vue&type=script&lang=ts&"
export * from "./JdsCandidateBubble.vue?vue&type=script&lang=ts&"
import style0 from "./JdsCandidateBubble.vue?vue&type=style&index=0&id=6885cd28&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6885cd28",
  null
  
)

export default component.exports